export var ApplyConversationFlagStateStoreUpdateActionName = 'applyConverstionFlagStateStoreUpdate';
//# sourceMappingURL=mailStoreActionTypes.js.map